import AthleteForm from './athleteForm';

export default AthleteForm;